import { render } from "./DetalheAssinatura.vue?vue&type=template&id=b7179758&scoped=true"
import script from "./DetalheAssinatura.vue?vue&type=script&lang=js"
export * from "./DetalheAssinatura.vue?vue&type=script&lang=js"

import "./DetalheAssinatura.vue?vue&type=style&index=0&id=b7179758&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7179758"]])

export default __exports__